import HeaderContact from './Headers/HeaderContact.js';
import FooterContact from './Footers/FooterContact.js';
import '../styles/Contact.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';

function Contact() {
    return (
        <div className = "Contact">
            <HeaderContact/>

                <div id = "contactHeaderImg">
                    <span>Contact Us</span>
                </div>

                <div id = "letsTalk">
                    <span>Get In Touch</span>
                    <p>Have a question or want to place an order? Fill out the form and we’ll get back to you as soon as possible.</p>

                    <label for = "name">
                        Your Name
                        <input type = "text" id = "name" name = "name" className = "nameAndEmail" placeholder = "Your name"></input>
                    </label>

                    <label for = "email">
                        Your Email
                        <input type = "email" id = "email" name = "email" className = "nameAndEmail" placeholder = "Your email address"></input>
                    </label>

                    <label for = "message">
                        Your Message
                        <input type = "textarea" id = "message" name = "message" placeholder = "Write your message"></input>
                    </label>

                    <button id = "contactSubmit">Send message</button>
                </div>

                <div id = "location">
                    <div id = "getLocation">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d4869.020903170155!2d16.862736560598307!3d52.397424374014264!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spl!2spl!4v1668423520104!5m2!1spl!2spl"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title = "poznan"></iframe>
                    </div>

                    <div id = "contactAddress" className = "contactDetails">
                        <div id = "locationIcon" className = "locationCircles">
                            <FontAwesomeIcon icon = {faLocationDot}/>
                        </div>
                        <span>Bułgarska 17, 60-320, Poznań</span>
                    </div>

                    <div id = "contactPhone" className = "contactDetails">
                        <div id = "phoneIcon" className = "locationCircles">
                            <FontAwesomeIcon icon = {faPhone}/>
                        </div>
                        <span>+48 123 456 789</span>
                    </div>

                    <div id = "contactEmail" className = "contactDetails">
                        <div id = "emailIcon" className = "locationCircles">
                            <FontAwesomeIcon icon = {faEnvelope}/>
                        </div>
                        <span>contact@mjsnfood.com</span>
                    </div>
                </div>
            <FooterContact/>
        </div>
    )
}

export default Contact;